import React, { useMemo, useState } from "react";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import {
  useAddStudioServicesMutation,
  useGetUserStudioDetailQuery,
} from "../../../api/user/associaStudioApi";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import { actions as appActions } from "../../../../app/appSlice";
import CoreCard from "../../../../app/core/components/CoreCard/CoreCard";
import CoreButtonIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { t } from "i18next";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";

const AssociaStudioDettaglioPage = () => {
  const [code, setCode] = useState("");
  // const [isValidCode, setIsValidCode] = useState(true);
  // const [disabled,setDisabled] = useState(true)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const studioId = useSelector((state) => state.app.studioId);

  const { data: studioDetail, isLoading: studioDetailLoading } =
    useGetUserStudioDetailQuery(params.id);

  const [addStudioServices, { isLoading: isAddingStudioService }] =
    useAddStudioServicesMutation();

  // const handleChangeCode = (e) => {
  //   setIsValidCode(true);
  //   setCode(e.target.value);
  // };

  const disabled = useMemo(() => {
    return code.length === 0;
  }, [code]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const studioData = {
      StudioId: params.id,
      StudioCode: code,
    };
    addStudioServices(studioData)
      .then(() => {
        setCode("");
        dispatch(
          appActions.setStudioId({
            studioId: studioData.StudioId,
          })
        );
        dispatch(
          appActions.setColors({
            primaryColor: studioDetail.Data.primaryColor,
            secondaryColor: studioDetail.Data.secondaryColor,
          })
        );
        dispatch(
          appActions.setLogoImageURL({
            logoImageUrl: studioDetail.Data.logoImageUrl,
          })
        );
        dispatch(
          appActions.updateStudioName({
            studioName: studioDetail.Data.name,
          })
        );
        toast.success(`${t("StudioAssociated")}`);
        navigate(`/auth/user/${t("documentManagement")}`); //TOODO navigate("/auth/user/dashboard");
      })
      .catch((error) => {
        toast.error(`${t("StudioNotAssociated")}`);
        if (
          error.response &&
          error.response.status === 200 &&
          error.response.data &&
          error.response.data.exception
        ) {
          toast.error(`${t("StudioNotAssociated")}`);
        } else {
          toast.error(`${t("StudioNotAssociated")}`);
        }
      });
  };

  if (studioDetailLoading) {
    return <CoreSpinner />;
  }

  return (
    <>
      {studioId ? (
        <div className="flex items-center justify-center h-full ">
          <h3 className=" text-gray">{t("AlreadyAssociated")}</h3>
        </div>
      ) : (
        <div className="flex justify-center">
          <div className="w-7/12">
            <div className="flex items-center">
              <CoreBack />
              <h2 className="w-full text-center me-8">
                {studioDetail?.Data?.name}
              </h2>
            </div>
            <div className="flex justify-center items-center ">
              <div className="flex ">
                <CoreCard
                  className="flex justify-center"
                  width={"10rem"}
                  height={"10rem"}
                  child={
                    <img
                      alt={
                        studioDetail?.Data?.logoImageUrl
                          ? "logo"
                          : "placeholder"
                      }
                      src={
                        studioDetail?.Data?.logoImageUrl
                          ? studioDetail?.Data?.logoImageUrl
                          : "/img/placeholder-logo.svg"
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  }
                />
              </div>
            </div>
            <div className="w-full py-4">
              <h3>{t("Description")}</h3>
              <div>
                {studioDetail?.Data?.description || (
                  <p className="text-gray">N/A</p>
                )}
              </div>
            </div>
            <div className="flex space-x-6 ">
              <div className="flex flex-col w-6/12">
                <h3>{t("Services")}</h3>
                {studioDetail?.Data?.services?.map((servizio, idx) => (
                  <div
                    style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                    key={idx}
                  >
                    {servizio.name}
                  </div>
                ))}
              </div>
              <div className="flex flex-col items-end  w-6/12">
                {studioId ? (
                  <div>
                    <h3>{t("Contacts")}</h3>
                    <div className="w-full flex flex-col">
                      <CoreButtonIcon
                        disabled
                        className={"ml-2"}
                        icon={
                          <EmailRoundedIcon
                            style={{
                              color: `${studioDetail?.Data?.primaryColor}`,
                            }}
                          />
                        }
                        testo={studioDetail?.Data?.email || "N/A"}
                      />
                      <CoreButtonIcon
                        disabled
                        className={"ml-2"}
                        icon={
                          <LocalPhoneIcon
                            style={{
                              color: `${studioDetail?.Data?.primaryColor}`,
                            }}
                          />
                        }
                        testo={studioDetail?.Data?.phoneNumber || "N/A"}
                      />
                      <CoreButtonIcon
                        disabled
                        className={"ml-2"}
                        icon={
                          <LanguageIcon
                            style={{
                              color: `${studioDetail?.Data?.primaryColor}`,
                            }}
                          />
                        }
                        testo={studioDetail?.Data?.website || "N/A"}
                      />
                      <CoreButtonIcon
                        disabled
                        className={"ml-2 text-neutral-900 "}
                        icon={
                          <LocationOnIcon
                            style={{
                              color: `${studioDetail?.Data?.primaryColor}`,
                            }}
                          />
                        }
                        testo={studioDetail?.Data?.address || "N/A"}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <h3 className="ml-2">{t("Address")}</h3>
                    <div className="">
                      <CoreButtonIcon
                        disabled
                        className={"ml-2 text-neutral-900 "}
                        icon={
                          <LocationOnIcon
                            style={{
                              color: `${studioDetail?.Data?.primaryColor}`,
                            }}
                          />
                        }
                        testo={studioDetail?.Data?.address || "N/A"}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* <Box className="flex items-center justify-center mt-2 mb-4">
                <CoreInputField
                  name="Inserisci codice"
                  //required={true}
                  value={code}
                  onChange={handleChangeCode}
                  label="Inserisci codice"
                  type="text"
                  error={!isValidCode}
                />
              </Box> */}

            <div className="py-10 flex justify-center">
              <CoreButton
                disabled={isAddingStudioService}
                testo={isAddingStudioService ? t("Wait") : t("Associate")}
                className="btn-round"
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssociaStudioDettaglioPage;
